import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { SUITABILITY_EMPTY } from 'apps/foodProfile/consts';

function generateBadgeTitle(suitability) {
  const {
    unsuitableConditions,
    mayContainIngredients,
  } = suitability;
  const titleParts = [];
  if (unsuitableConditions.length) titleParts.push(`Contains ${unsuitableConditions.join(', ')}.`);
  if (mayContainIngredients.length) titleParts.push(`May contain ${mayContainIngredients.join(', ')}.`);

  return titleParts.join(' ');
}

export default class FoodProfileBadge extends PureComponent {
  static propTypes = {
    isBadgeEnabled: PropTypes.bool,
    suitability: PropTypes.object,
  }

  render() {
    const {
      isBadgeEnabled,
      suitability = SUITABILITY_EMPTY,
    } = this.props;
    const showFPBadge = isBadgeEnabled && suitability.isSuitable === 0;
    const title = generateBadgeTitle(suitability) || 'This product contains food allergies and intolerance';

    return showFPBadge ? (
      <span
        className="badge-fm"
        title={title}
      >
        FLAGGED
      </span>
    ) : null;
  }
}
